import { Command } from '@ckeditor/ckeditor5-core';
export default class InsertRawHtmlCommand extends Command {
    execute() {
        this.editor.model.change((writer) => {
            this.editor.model.insertContent(createRawHtml(writer));
        });
    }
    refresh() {
        const model = this.editor.model;
        this.isEnabled = true;
    }
}
function createRawHtml(writer) {
    const rawHtml = writer.createElement('rawHtml');
    const rawHtmlContent = writer.createElement('rawHtmlContent');
    writer.append(rawHtmlContent, rawHtml);
    return rawHtml;
}
